import { useFocusEffect } from 'expo-router'
import { useCallback, useMemo, useState } from 'react'
import { type ViewProps } from 'react-native'

import { IS_WEB } from '@/lib'

type FocusViewProps = Pick<
  ViewProps,
  'accessible' | 'accessibilityElementsHidden' | 'aria-hidden' | 'importantForAccessibility'
>

export const useFocusViewProps = (): [props: FocusViewProps, isHidden: boolean] => {
  const [isBlurred, setIsBlurred] = useState(true)
  const props = useMemo<FocusViewProps>(
    () => ({
      accessibilityElementsHidden: isBlurred,
      'aria-hidden': isBlurred,
      importantForAccessibility: isBlurred ? 'no-hide-descendants' : 'auto'
    }),
    [isBlurred]
  )

  useFocusEffect(
    useCallback(() => {
      setIsBlurred(false)

      return () => {
        setIsBlurred(true)
      }
    }, [])
  )

  return [props, isBlurred && IS_WEB]
}
